import React from "react";
import { isIOS } from "react-device-detect";
import { Modal } from "react-bootstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { moment } from "../common/common";

// import { Range } from 'rc-slider';
import { getCarDetail, getCarCalendar, updateCar } from "../../model/car";

import { commonErr } from "../common/errors";
import { LoadingInline, LoadingOverlay } from "../common/loading";
import { MessageBox } from "../common/messagebox";
import {
	getBookingTimes,
	DEFAULT_INSTANT_RANGE_FROM,
	DEFAULT_INSTANT_RANGE_TO,
	listInstantRangeFrom,
	listInstantRangeTo,
	stypes,
	arrayToString,
} from "../common/common";

import { IcPlusCircleGreen, IcCloseCircle } from "../common/svg";

// const calendarTemplate =
// 	'<div class="daterangepicker dropdown-menu home">' +
// 	'<p class="c-title">Chọn ngày</p>' +
// 	'<div class="calendar left">' +
// 	'<div class="daterangepicker_input hidden">' +
// 	'<input class="input-mini form-control" type="text" name="daterangepicker_start" value="" />' +
// 	'<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
// 	'<div class="calendar-time">' +
// 	"<div></div>" +
// 	'<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
// 	"</div>" +
// 	"</div>" +
// 	'<div class="calendar-table"></div>' +
// 	"</div>" +
// 	"</div>" +
// 	"</div>";

const PickupReturnTimes = ({ times, i, array, arrayName, onHandleSelectTimeChange, onRemoveTimePickReturn }) => {
	return (
		<React.Fragment>
			<div className="form-default form-pick-return-time">
				<div className="line-form">
					<label className="label">Từ</label>
					<div className="wrap-select">
						<select
							name="fromTime"
							onChange={(e) => onHandleSelectTimeChange(e, i, array, arrayName)}
							value={times.fromTime * 1}>
							{getBookingTimes().map((time) => (
								<option value={time.value * 60} key={`s_${time.value}`}>
									{time.label}
								</option>
							))}
						</select>
					</div>
				</div>
				<div className="line-form">
					<label className="label">Đến</label>
					<div className="wrap-select">
						<select
							name="toTime"
							onChange={(e) => onHandleSelectTimeChange(e, i, array, arrayName)}
							value={times.toTime * 1}>
							{getBookingTimes().map((time) => (
								<option value={time.value * 60} key={`s_${time.value}`}>
									{time.label}
								</option>
							))}
						</select>
					</div>
				</div>
				{array.length > 1 && (
					<a className="rm-mintimes" onClick={() => onRemoveTimePickReturn(i, array, arrayName)}>
						<IcCloseCircle />
					</a>
				)}
			</div>
		</React.Fragment>
	);
};

const MinTimes = ({ stype, minTimes, index, onDateRangeChange, onDayOrHourNumbersChange, onRemoveMinTimes }) => {
	const isSD = stype === stypes.SD;
	const calendarTemplate = () => {
		return `<div class="daterangepicker dropdown-menu home">
					<p class="c-title">Chọn ngày</p>
					<div class="calendar left">
						<div class="calendar-table" style="min-height: 281px"></div>
					</div>
					<div class="calendar right">
						<div class="calendar-table" style="min-height: 281px"></div>
					</div>
					<div class="ranges"> 
						<div class="range_inputs"> 
							<button class="applyBtn" disabled="disabled" type="button"></button>  
						</div> 
					</div> 
				</div>`;
	};

	return (
		<div className="form-default form-min-times">
			<div className="line-form has-timer">
				<label className="label">Bắt đầu</label>
				<div className="wrap-input has-dropdown">
					<DateRangePicker
						initialSettings={{
							startDate: minTimes.startDate || moment().startOf("day"),
							endDate: minTimes.endDate || moment().startOf("day"),
							minDate: moment().startOf("day"),
							timePicker: false,
							singleDateRangePicker: false,
							isIOs: isIOS,
							template: calendarTemplate(),
							autoApply: false,
							buttonClasses: ["btn btn--m btn-primary"],
							locale: {
								applyLabel: "Áp dụng",
							},
							opens: "center",
							parentEl: "#booking-sidebar",
							linkedCalendars: true,
							singelSelect: true,
						}}
						onHide={(event, picker) => onDateRangeChange(event, picker, index)}>
						<span className="value">{minTimes.startDate ? minTimes.startDate.format("DD/MM/YYYY") : "Chọn ngày"}</span>
					</DateRangePicker>
					{/* <DateRangePicker
						startDate={minTimes.startDate || moment().startOf("day")}
						endDate={minTimes.endDate || moment().startOf("day")}
						minDate={moment().startOf("day")}
						singleDateRangePicker={true}
						singleSelect={true}
						autoApply={true}
						isIOs={isIOS}
						linkedCalendars={false}
						onHide={(event, picker) => onDateRangeChange(event, picker, index)}
						template={calendarTemplate}
						buttonClasses={["hidden"]}
						opens={"center"}
						parentEl={"#booking-sidebar"}
						pickingEndDateOnly={false}>
						<span className="value">{minTimes.startDate ? minTimes.startDate.format("DD/MM/YYYY") : "Chọn ngày"}</span>
					</DateRangePicker> */}
				</div>
			</div>
			<div className="line-form has-timer">
				<label className="label">Kết thúc</label>

				<div className="wrap-input has-dropdown">
					<DateRangePicker
						initialSettings={{
							startDate: minTimes.startDate || moment().startOf("day"),
							endDate: minTimes.endDate || moment().startOf("day"),
							minDate: moment().startOf("day"),
							timePicker: false,
							singleDateRangePicker: false,
							isIOs: isIOS,
							template: calendarTemplate(),
							autoApply: false,
							buttonClasses: ["btn btn--m btn-primary"],
							locale: {
								applyLabel: "Áp dụng",
							},
							opens: "center",
							parentEl: "#booking-sidebar",
							linkedCalendars: true,
							singelSelect: true,
						}}
						onHide={(event, picker) => onDateRangeChange(event, picker, index)}>
						<span className="value">{minTimes.endDate ? minTimes.endDate.format("DD/MM/YYYY") : "Chọn ngày"}</span>
					</DateRangePicker>
					{/* <DateRangePicker
						startDate={minTimes.startDate || moment().startOf("day")}
						endDate={minTimes.endDate || moment().startOf("day")}
						minDate={moment().startOf("day")}
						singleDateRangePicker={true}
						singleSelect={true}
						autoApply={true}
						isIOs={isIOS}
						buttonClasses={["hidden"]}
						pickingEndDateOnly={true}
						opens={"center"}
						linkedCalendars={false}
						onHide={(event, picker) => onDateRangeChange(event, picker, index)}
						template={calendarTemplate}
						parentEl={"#booking-sidebar"}>
						<span className="value">
							{minTimes.endDate && minTimes.endDate.isValid() ? minTimes.endDate.format("DD/MM/YYYY") : "Chọn ngày"}
						</span>
					</DateRangePicker> */}
				</div>
			</div>

			<div className="line-form">
				<label className="label">Số {isSD ? "ngày" : "giờ"}</label>
				<div className="d-flex wrap-input-label">
					<div className="wrap-input">
						<input
							type="number"
							value={minTimes.dayOrHourNumbers}
							onChange={(event) => onDayOrHourNumbersChange(event, index)}
						/>
					</div>
				</div>
			</div>
			<a className="rm-mintimes" onClick={() => onRemoveMinTimes(index)}>
				<IcCloseCircle />
			</a>
		</div>
	);
};

export default class CarSettingRentingTime extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			updateErrMsg: "",
			isShowConfirmInstant: false,
			pickupTimesArray: [
				{
					fromTime: 0,
					toTime: 86400,
				},
			],
			returnTimesArray: [
				{
					fromTime: 0,
					toTime: 86400,
				},
			],

			minTimesArray: [
				{
					startDate: null,
					endDate: null,
					dayOrHourNumbers: 0,
				},
			],
		};
		this.stype = this.props.stype;
		this.isSD = this.props.stype === stypes.SD;
	}

	init = (carId) => {
		getCarDetail(carId).then((carDetailResp) => {
			if (carDetailResp.data.error >= commonErr.SUCCESS && carDetailResp.data.data.car) {
				getCarCalendar(carId, undefined, undefined, "cs").then((carCalendarResp) => {
					if (carCalendarResp.data.error >= commonErr.SUCCESS && carCalendarResp.data.data) {
						let carDetail, carCalendar;
						if (this.isSD) {
							carDetail = carDetailResp.data.data.car;
							carCalendar = carCalendarResp.data.data;
						} else {
							carDetail = carDetailResp.data.data.car.wdFull;
							carCalendar = carCalendarResp.data.data.wdCalendar;
						}
						const { pickupTimes, returnTimes, minTimes } = carCalendar;

						this.setState({
							err: carDetailResp.data.error,
							car: carDetail,
							isInstantly: carDetail.instantEnable === 1,
							instantRangeFrom:
								carDetail.instantRangeFrom > 0 ? carDetail.instantRangeFrom : DEFAULT_INSTANT_RANGE_FROM,
							instantRangeTo: carDetail.instantRangeTo > 0 ? carDetail.instantRangeTo : DEFAULT_INSTANT_RANGE_TO,
							pickupTimesArray: pickupTimes
								? pickupTimes.map((pickupTime) => {
										return {
											fromTime: pickupTime.s,
											toTime: pickupTime.e,
										};
								  })
								: [
										{
											fromTime: 0,
											toTime: 86400,
										},
								  ],
							returnTimesArray: returnTimes
								? returnTimes.map((returnTime) => {
										return {
											fromTime: returnTime.s,
											toTime: returnTime.e,
										};
								  })
								: [
										{
											fromTime: 0,
											toTime: 86400,
										},
								  ],
							minTimesArray: minTimes
								? minTimes.map((minTimes) => {
										return {
											startDate: moment(minTimes.s),
											endDate: moment(minTimes.e),
											dayOrHourNumbers: this.isSD ? minTimes.h / 24 : minTimes.h,
										};
								  })
								: [
										{
											startDate: null,
											endDate: null,
											dayOrHourNumbers: 0,
										},
								  ],
						});
					} else {
						this.setState({
							err: carDetailResp.data.error,
						});
					}
				});
			} else {
				this.setState({
					err: carDetailResp.data.error,
				});
			}
		});
	};

	componentDidMount() {
		const { car } = this.props;
		this.init(car.id);
	}

	componentWillReceiveProps(props) {
		this.stype = props.stype;
		this.isSD = props.stype === stypes.SD;
		const { car } = props;
		this.init(car.id);
	}

	toggleInstantly = () => {
		var instant = !this.state.isInstantly;
		this.setState({
			isInstantly: instant,
		});
		if (instant) {
			this.setState({
				instantRangeFrom:
					!this.state.instantRangeFrom || this.state.instantRangeFrom === 0
						? DEFAULT_INSTANT_RANGE_FROM
						: this.state.instantRangeFrom,
				instantRangeTo:
					!this.state.instantRangeTo || this.state.instantRangeTo === 0
						? DEFAULT_INSTANT_RANGE_TO
						: this.state.instantRangeTo,
			});
		}
	};

	onInstantRangeFromChange = (event) => {
		this.setState({
			instantRangeFrom: event.target.value,
		});
	};

	onInstantRangeToChange = (event) => {
		this.setState({
			instantRangeTo: event.target.value,
		});
	};

	close = () => {
		this.setState({
			isShowConfirmInstant: false,
		});
	};

	onHandleSelectTimeChange = (event, index, array, arrayName) => {
		let timePickReturnArr = [...array];
		let value = event.target.value * 1;
		const { name } = event.target;

		if (name === "fromTime" && value >= timePickReturnArr[index].toTime) {
			let time = value + 14400;

			timePickReturnArr[index] = {
				...timePickReturnArr[index],
				toTime: time > 86400 ? time - 86400 : time,
			};
		}

		if (name === "toTime" && value <= timePickReturnArr[index].fromTime) {
			let time = value - 14400;
			timePickReturnArr[index] = {
				...timePickReturnArr[index],
				fromTime: time < 0 ? 86400 + time : time,
			};
		}

		timePickReturnArr[index] = {
			...timePickReturnArr[index],
			[name]: value,
		};

		this.setState({
			[arrayName]: timePickReturnArr,
		});
	};

	onAddPickupReturnArr = (array, arrayName) => {
		let timePickReturnArr = [...array];
		if (timePickReturnArr[0].toTime >= 84600) {
			timePickReturnArr.push({
				fromTime: 0,
				toTime: 86400,
			});
		} else {
			timePickReturnArr.push({
				fromTime: timePickReturnArr[0].toTime + 1800,
				toTime: 86400,
			});
		}

		this.setState({
			[arrayName]: timePickReturnArr,
		});
	};

	onRemoveTimePickReturn = (index, array, arrayName) => {
		let timePickReturnArr = [...array];

		if (index === 0 && array.length === 1) {
			timePickReturnArr[0] = {
				...timePickReturnArr[0],
				fromTime: 0,
				toTime: 86400,
			};
		} else {
			timePickReturnArr.splice(index, 1);
		}
		this.setState({
			[arrayName]: timePickReturnArr,
		});
	};

	checkValidPickTimes = (timeArr) => {
		if (timeArr && timeArr.length > 1) {
			for (let i = 0; i < timeArr.length - 1; i++) {
				if (timeArr[i].fromTime <= timeArr[i + 1].fromTime && timeArr[i + 1].fromTime <= timeArr[i].toTime) {
					return false;
					break;
				}
				if (timeArr[i].fromTime <= timeArr[i + 1].toTime && timeArr[i + 1].toTime <= timeArr[i].toTime) {
					return false;
					break;
				}
				if (timeArr[i + 1].fromTime <= timeArr[i].fromTime && timeArr[i].fromTime <= timeArr[i + 1].toTime) {
					return false;
					break;
				}
				if (timeArr[i + 1].toTime <= timeArr[i].toTime && timeArr[i].toTime <= timeArr[i + 1].toTime) {
					return false;
					break;
				}
			}
		}

		return true;
	};

	onDateRangeChange = (event, picker, index) => {
		if (picker.startDate && picker.endDate) {
			const startDate = picker.startDate.startOf("day");
			const endDate = picker.endDate.startOf("day");
			if (endDate < startDate) {
				return;
			}
			let minTimesArray = [...this.state.minTimesArray];
			minTimesArray[index] = {
				...minTimesArray[index],
				startDate,
				endDate,
			};
			this.setState({
				minTimesArray,
			});
		}
	};

	onDayOrHourNumbersChange = (event, index) => {
		const value = parseInt(event.target.value);
		if (value < 1) {
			return;
		}
		let minTimesArray = [...this.state.minTimesArray];
		minTimesArray[index] = {
			...minTimesArray[index],
			dayOrHourNumbers: value,
		};
		this.setState({
			minTimesArray,
		});
	};

	onAddMinTimes = () => {
		let minTimesArray = [...this.state.minTimesArray];
		minTimesArray.push({
			startDate: null,
			endDate: null,
			dayOrHourNumbers: 0,
		});
		this.setState({
			minTimesArray,
		});
	};

	onRemoveMinTimes = (index) => {
		let minTimesArray = [...this.state.minTimesArray];

		if (index === 0 && this.state.minTimesArray.length === 1) {
			minTimesArray[0] = {
				startDate: null,
				endDate: null,
				dayOrHourNumbers: 0,
			};
		} else {
			minTimesArray.splice(index, 1);
		}
		this.setState({
			minTimesArray,
		});
	};

	hideMessageBox = () => {
		this.setState({
			updateErrMsg: "",
		});
	};

	isValidAllMinTimes = () => {
		const { minTimesArray } = this.state;
		if (
			minTimesArray.length === 1 &&
			!minTimesArray[0].startDate &&
			!minTimesArray[0].endDate &&
			minTimesArray[0].dayOrHourNumbers === 0
		) {
			return true;
		}
		for (let minTimes of minTimesArray) {
			if (!(minTimes.startDate && minTimes.endDate) && minTimes.dayOrHourNumbers > 0) {
				return false;
			}
		}
		return true;
	};

	isValidPickupTimesAndReturnTimes = () => {
		const { pickupTimesArray, returnTimesArray } = this.state;

		for (let i = 0; i < pickupTimesArray.length; i++) {
			let pickupHour = pickupTimesArray[i].toTime - pickupTimesArray[i].fromTime;
			if (pickupHour < 14400) {
				return false;
				break;
			}
		}

		for (let i = 0; i < returnTimesArray.length; i++) {
			let returnHour = returnTimesArray[i].toTime - returnTimesArray[i].fromTime;
			if (returnHour < 14400) {
				return false;
				break;
			}
		}

		return true;
	};

	callingUpdateCarInfo = () => {
		if (!this.isValidPickupTimesAndReturnTimes() && this.isSD) {
			this.setState({
				err: commonErr.FAIL,
				updateErrMsg: `Khoảng thời gian giao nhận xe phải cách nhau tối thiểu 4 tiếng`,
			});
		} else if (!this.isValidAllMinTimes()) {
			this.setState({
				err: commonErr.FAIL,
				updateErrMsg: "Vui lòng nhập giá trị mốc thời gian còn trống",
			});
		} else if (this.state.isInstantly) {
			this.setState({
				isShowConfirmInstant: true,
			});
		} else {
			this.updateCarInfo();
		}
	};

	updateCarInfo = () => {
		this.setState({
			err: commonErr.LOADING,
			isShowConfirmInstant: false,
		});
		const { isInstantly, instantRangeFrom, instantRangeTo, pickupTimesArray, returnTimesArray, minTimesArray } =
			this.state;
		const { car } = this.props;
		let pickupTimes;
		let returnTimes;
		let minTimes;
		let data;

		pickupTimes = pickupTimesArray
			.map((pickupTimes) => {
				return `${pickupTimes.fromTime}-${pickupTimes.toTime}`;
			})
			.join(",");

		returnTimes = returnTimesArray
			.map((returnTimes) => {
				return `${returnTimes.fromTime}-${returnTimes.toTime}`;
			})
			.join(",");

		if (
			minTimesArray.length === 1 &&
			!minTimesArray[0].startDate &&
			!minTimesArray[0].endDate &&
			minTimesArray[0].dayOrHourNumbers === 0
		) {
			minTimes = "";
		} else {
			minTimes = minTimesArray
				.map((minTimes) => {
					return `${minTimes.startDate.valueOf()}-${minTimes.endDate.valueOf()}-${
						this.isSD ? minTimes.dayOrHourNumbers * 24 : minTimes.dayOrHourNumbers
					}`;
				})
				.join(",");
		}

		if (this.isSD) {
			data = {
				instant: isInstantly,
				instantRangeFrom,
				instantRangeTo,
				pickupTimes,
				returnTimes,
				minTimes,
			};
		} else {
			data = {
				withDriver: true,
				wdInstant: isInstantly,
				wdInstantRangeFrom: instantRangeFrom,
				wdInstantRangeTo: instantRangeTo,
				wdMinTimes: minTimes,
			};
		}
		updateCar(car.id, data).then((updateCarResp) => {
			this.setState({
				err: updateCarResp.data.error,
				updateErrMsg: updateCarResp.data.errorMessage,
			});
		});
	};

	render() {
		var content;
		const { pickupTimesArray, returnTimesArray, minTimesArray } = this.state;
		const pickupName = "pickupTimesArray";
		const returnName = "returnTimesArray";
		const invalidUpdate = !this.checkValidPickTimes(pickupTimesArray) || !this.checkValidPickTimes(returnTimesArray);

		if (this.state.err === commonErr.INNIT) {
			content = <LoadingInline />;
		} else {
			var selectInstantRangeContent = (
				<div className="form-default form-instant-booking">
					<div className="line-form">
						<label className="label">Giới hạn từ</label>
						<div className="wrap-select">
							<select
								value={!this.state.instantRangeFrom ? DEFAULT_INSTANT_RANGE_FROM : this.state.instantRangeFrom}
								onChange={this.onInstantRangeFromChange}>
								{listInstantRangeFrom &&
									listInstantRangeFrom.map((option) => (
										<option key={option.key} value={option.key}>
											{option.value}
										</option>
									))}
							</select>
						</div>
					</div>
					<div className="line-form">
						<label className="label">Cho đến</label>
						<div className="wrap-select">
							<select
								value={!this.state.instantRangeTo ? DEFAULT_INSTANT_RANGE_TO : this.state.instantRangeTo}
								onChange={this.onInstantRangeToChange}>
								{listInstantRangeTo &&
									listInstantRangeTo.map((option) => (
										<option key={option.key} value={option.key}>
											{option.value}
										</option>
									))}
							</select>
						</div>
					</div>
				</div>
			);

			content = (
				<div className="content">
					<Modal show={this.state.isShowConfirmInstant} onHide={this.close} dialogClassName="modal-sm modal-dialog">
						<Modal.Header closeButton={true} closeLabel={""}>
							<h5>Thông báo</h5>
						</Modal.Header>
						<Modal.Body>
							<div className="module-register" style={{ background: "none", padding: "0" }}>
								<div className="form-default form-s">
									<div className="textAlign-center">
										<p style={{ color: "#141414" }}>
											Bạn có chắc chắn rằng xe của bạn luôn sẵn sàng cho thuê trong khoảng thời gian trên?
										</p>
										<p style={{ fontSize: "12px", color: "#141414" }}>
											Bạn cần đảm bảo việc cần cập nhật lịch bận xe thường xuyên, trường hợp hủy chuyến sau khi khách
											đặt cọc vì chưa cập nhật lịch bận sẽ áp dụng phí hủy chuyến (100% tiền đặt cọc)
										</p>
									</div>
									<div className="space m" />
									<div className="space m" />
									<div className="wrap-btn has-2btn">
										<div className="wr-btn">
											<a className="btn btn-secondary btn--m" onClick={this.close}>
												Bỏ qua
											</a>
										</div>
										<div className="wr-btn">
											<a className="btn btn-primary btn--m" onClick={this.updateCarInfo}>
												Tôi chắc chắn
											</a>
										</div>
									</div>
								</div>
							</div>
						</Modal.Body>
					</Modal>

					{this.state.err === commonErr.LOADING && <LoadingOverlay />}
					<MessageBox
						error={this.state.err}
						message={this.state.updateErrMsg}
						show={this.state.updateErrMsg !== ""}
						hideModal={this.hideMessageBox}
					/>

					<div className="content-container">
						<div className="form-default">
							<div className="space m"></div>
							<h3 className="title text-inline">Đặt xe nhanh</h3>
							<div className="tooltip">
								<i className="ic ic-question-mark"></i>
								<div className="tooltip-text">
									Tính năng cho phép khách hàng đặt xe ngay lập tức không cần chủ xe phê duyệt{" "}
									<span> (Phù hợp với các chủ xe không thường xuyên online và kiểm tra điện thoại.) </span>
								</div>
							</div>
							<div className="position-relative pos-1">
								<div className="switch-on-off" style={{ right: "0", position: "absolute", bottom: "10px" }}>
									<input
										className="switch-input"
										id="cb-instant-booking"
										type="checkbox"
										checked={this.state.isInstantly}
										onChange={this.toggleInstantly}
									/>
									<label className="switch-label" htmlFor="cb-instant-booking"></label>
								</div>
							</div>
							<span className="note marginBottom-s">
								Tự động đồng ý đối với tất cả yêu cầu thuê xe trong khoảng thời gian cài đặt
							</span>
							{this.state.isInstantly && selectInstantRangeContent}

							<div className="line"></div>

							{this.isSD && (
								<React.Fragment>
									<h3 className="title">Thời gian giao xe</h3>
									<div className="space m"></div>

									{pickupTimesArray.map((pickupTimes, index) => (
										<PickupReturnTimes
											key={index}
											i={index}
											times={pickupTimes}
											array={pickupTimesArray}
											arrayName={pickupName}
											onHandleSelectTimeChange={this.onHandleSelectTimeChange}
											onRemoveTimePickReturn={this.onRemoveTimePickReturn}
										/>
									))}

									{pickupTimesArray.length < 2 && (
										<a
											className="text-primary add-times"
											onClick={() => this.onAddPickupReturnArr(pickupTimesArray, pickupName)}>
											<div className="wrap-svg">
												<IcPlusCircleGreen />
											</div>
											Thêm mốc thời gian
										</a>
									)}
									{!this.checkValidPickTimes(pickupTimesArray) && (
										<p class="text-danger">Khoảng thời gian giao xe không được trùng nhau</p>
									)}
									<div className="line"></div>

									<h3 className="title">Thời gian nhận xe</h3>
									<div className="space m"></div>
									{returnTimesArray.map((returnTimes, index) => (
										<PickupReturnTimes
											key={index}
											i={index}
											times={returnTimes}
											array={returnTimesArray}
											arrayName={returnName}
											onHandleSelectTimeChange={this.onHandleSelectTimeChange}
											onRemoveTimePickReturn={this.onRemoveTimePickReturn}
										/>
									))}
									{returnTimesArray.length < 2 && (
										<a
											className="text-primary add-times"
											onClick={() => this.onAddPickupReturnArr(returnTimesArray, "returnTimesArray")}>
											<div className="wrap-svg">
												<IcPlusCircleGreen />
											</div>
											Thêm mốc thời gian
										</a>
									)}
									{!this.checkValidPickTimes(returnTimesArray) && (
										<p class="text-danger">Khoảng thời gian nhận xe không được trùng nhau</p>
									)}
									<div className="line"></div>
								</React.Fragment>
							)}

							{/* <h3 className="title">Thời gian thuê tối thiểu</h3> */}
							{/* <div className="space m"></div> */}
							{/* {minTimesArray.map((minTimes, index) => (
								<MinTimes
									key={index}
									index={index}
									minTimes={minTimes}
									onDateRangeChange={this.onDateRangeChange}
									onDayOrHourNumbersChange={this.onDayOrHourNumbersChange}
									onRemoveMinTimes={this.onRemoveMinTimes}
									stype={this.stype}
								/>
							))} */}
							{/* <a className="text-primary add-times" onClick={this.onAddMinTimes}>
								<div className="wrap-svg">
									<IcPlusCircleGreen />
								</div>
								Thêm mốc thời gian
							</a> */}
						</div>
						{/* <div className="line"></div> */}
						<a
							className="btn btn-primary btn--m"
							disabled={invalidUpdate ? "disabled" : ""}
							onClick={this.callingUpdateCarInfo}>
							Lưu thay đổi
						</a>
					</div>
				</div>
			);
		}
		return content;
	}
}
